import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./UsersDetailsWWGInfoTab.module.css";
import Button from "shared/Button";
import Card from "shared/Card";
import InfoItem from "DreamStream/Shared/InfoItem";
import UnlinkModal from "DreamStream/UsersPage/UnlinkModal";
import LinkModal from "DreamStream/UsersPage/LinkModal";
import ReinviteModal from "DreamStream/UsersPage/ReinviteModal";

/**
 * Content in WWG Info tab page when details button clicked.
 */

export function UsersDetailsWWGInfoTab({ membershipInfo, isLinked }) {
  const [reinviteModalOpen, setReinviteModalOpen] = useState(false);
  const [unLinkModalOpen, setUnLinkModalOpen] = useState(false);
  const [linkModalOpen, setLinkModalOpen] = useState(false);

  return (
    <>
      {isLinked ? (
        <div className={styles.container}>
          <Card className={styles.cardContainer}>
            <div className={styles.cardHeader}>
              <h5 className={styles.title}>MEMBERSHIP</h5>
              <div className={styles.btnDiv}>
                <Button
                  className={styles.resendBtn}
                  onClick={() => setReinviteModalOpen(true)}
                  size="tiny"
                  children="RESEND INVITE"
                />
                <Button
                  className={styles.unlinkBtn}
                  onClick={() => setUnLinkModalOpen(true)}
                  size="tiny"
                  children="UNLINK"
                />
              </div>
            </div>
            <div className={styles.hr}> </div>
            <div className={styles.infoContainer}>
              <div className={styles.infoDiv}>
                <InfoItem label="Status" description={membershipInfo.status} />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Since"
                  description={membershipInfo.date + " " + membershipInfo.time}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem label="Email" description={membershipInfo.wwgEmail} />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="IBO Number"
                  description={membershipInfo.iboNum}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Sponsor"
                  description={membershipInfo.sponsor}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Platinum"
                  description={membershipInfo.platinum}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Emerald"
                  description={membershipInfo.emerald}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Diamond"
                  description={membershipInfo.diamond}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Pin Level"
                  description={membershipInfo.pinLevel}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Account Status"
                  description={membershipInfo.accountStatus}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Membership Type"
                  description={membershipInfo.membershipType}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Is Fully Canceled"
                  description={membershipInfo.fullyCancelled ? "True" : "False"}
                />
              </div>

              <div className={styles.infoDiv}>
                <InfoItem
                  label="Next Bill Date"
                  description={membershipInfo.nextBillDate}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem
                  label="Signup Date"
                  description={membershipInfo.signUpDate}
                />
              </div>
              <div className={styles.infoDiv}>
                <InfoItem label="Region" description={membershipInfo.region} />
              </div>
            </div>
          </Card>
        </div>
      ) : (
        <div className={styles.container}>
          <Card className={styles.notLinkedCardContainer}>
            <div className={styles.cardHeader}>
              <h5 className={styles.title}>MEMBERSHIP</h5>
              <div className={styles.btnDiv}>
                <Button
                  className={styles.unlinkBtn}
                  onClick={() => setLinkModalOpen(true)}
                  size="tiny"
                  children="LINK"
                />
              </div>
            </div>
            <div className={styles.hr}> </div>
            <div className={styles.notLinkedDiv}>
              <p className={styles.text}>No WWG membership linked</p>
            </div>
          </Card>
        </div>
      )}

      <ReinviteModal
        isOpen={reinviteModalOpen}
        wwgEmail="wwgEmail@email.com"
        altEmail="altEmail@email.com"
        onClose={() => setReinviteModalOpen(false)}
        onClick={(e) => alert("Reinvite Member clicked " + e)}
      />

      <UnlinkModal
        isOpen={unLinkModalOpen}
        memberID="123456"
        dsId="001235"
        checked={(e) => e.target.value}
        onClose={() => setUnLinkModalOpen(false)}
        onClick={() => alert("Unlink member clicked ")}
      />

      <LinkModal
        isOpen={linkModalOpen}
        memberID="123456"
        dsId="001235"
        checked={false}
        onClose={() => setLinkModalOpen(false)}
        onClick={() => alert("Connect member ID ")}
      />
    </>
  );
}

UsersDetailsWWGInfoTab.propTypes = {
  /**
   * Object with the plugins info.
   */
  membershipInfo: PropTypes.shape({
    status: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    wwgEmail: PropTypes.string,
    iboNum: PropTypes.string,
    sponsor: PropTypes.string,
    platinum: PropTypes.string,
    emerald: PropTypes.string,
    diamond: PropTypes.string,
    pinLevel: PropTypes.string,
    accountStatus: PropTypes.string,
    membershipType: PropTypes.string,
    fullyCancelled: PropTypes.bool,
    nextBillDate: PropTypes.string,
    signUpDate: PropTypes.string,
    region: PropTypes.string,
  }),

  /**
   * 	Boolean to determine if a member is not yet linked or been linked.
   */
  isLinked: PropTypes.bool,
};
